var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeywordsNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 560,
    height: 498,
    viewBox: "0 0 560 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M434 118H272C268.817 118 265.765 119.291 263.515 121.59C261.264 123.889 260 127.007 260 130.258V485.742C260 488.993 261.264 492.111 263.515 494.41C265.765 496.709 268.817 498 272 498H548C551.183 498 554.235 496.709 556.485 494.41C558.736 492.111 560 488.993 560 485.742V195.839L434 118Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272 494.935C269.613 494.935 267.324 493.967 265.636 492.243C263.948 490.519 263 488.18 263 485.742V130.258C263 127.82 263.948 125.481 265.636 123.757C267.324 122.033 269.613 121.064 272 121.064H433.22L557 197.677V485.742C557 488.18 556.052 490.519 554.364 492.243C552.676 493.967 550.387 494.935 548 494.935H272Z",
    fill: "url(#paint0_radial_1125_327)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M489.381 236.045C486.627 237.668 483.356 238.108 480.285 237.269C477.214 236.43 474.594 234.381 473.001 231.571L433.221 121.064L557.001 197.126L489.381 236.045Z",
    fill: "#B86BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.381 223.787C492.627 225.41 489.356 225.85 486.285 225.011C483.214 224.172 480.594 222.123 479.001 219.313L433.221 121.064L557.001 197.126L495.381 223.787Z",
    fill: "url(#paint1_linear_1125_327)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M560 195.839L434 118H272C268.817 118 265.765 119.291 263.515 121.59C261.264 123.889 260 127.007 260 130.258V252.839H560V195.839Z",
    fill: "#C89100"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M557 197.677L433.22 121.064H272C269.613 121.064 267.324 122.033 265.636 123.757C263.948 125.481 263 127.82 263 130.258V252.839H557V197.677Z",
    fill: "url(#paint2_radial_1125_327)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M428 416H291V434H428V416Z",
    fill: "url(#paint3_radial_1125_327)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M529 416H441V434H529V416Z",
    fill: "url(#paint4_radial_1125_327)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M366 451H291V466H366V451Z",
    fill: "url(#paint5_radial_1125_327)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M379 284H291V301H379V284Z",
    fill: "url(#paint6_radial_1125_327)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M503 284H392V301H503V284Z",
    fill: "url(#paint7_radial_1125_327)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M428 316H291V334H428V316Z",
    fill: "url(#paint8_radial_1125_327)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M467 316H441V334H467V316Z",
    fill: "url(#paint9_radial_1125_327)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M516 316H479V334H516V316Z",
    fill: "url(#paint10_radial_1125_327)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M329 349H291V366H329V349Z",
    fill: "url(#paint11_radial_1125_327)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M491 349H341V366H491V349Z",
    fill: "url(#paint12_radial_1125_327)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M392 385H291V401H392V385Z",
    fill: "url(#paint13_radial_1125_327)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M516 385H404V401H516V385Z",
    fill: "url(#paint14_radial_1125_327)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M489.381 236.045C486.627 237.668 483.356 238.108 480.285 237.269C477.214 236.43 474.594 234.381 473.001 231.571L433.221 121.064L557.001 197.126L489.381 236.045Z",
    fill: "#C89100"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M495.381 223.787C492.627 225.41 489.356 225.85 486.285 225.011C483.214 224.172 480.594 222.123 479.001 219.313L433.221 121.064L557.001 197.126L495.381 223.787Z",
    fill: "#FFD059"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5139 327.021L103.363 279.383C129.282 313.941 160.771 332.673 205.584 333.803C230.21 334.369 254.272 328.151 275.346 315.717C279.463 319.996 290.283 331.462 292.221 333.48C266.222 350.194 236.024 358.591 204.938 357.865C169.976 356.977 136.629 344.381 109.904 322.015C110.146 321.53 79.0598 352.294 78.7368 352.616C86.4074 376.678 68.1595 403 41.3528 403C19.7138 402.919 3 385.479 3 363.84C3 336.145 29.7259 318.139 54.5139 327.021ZM341.07 123.226C356.492 148.499 364.97 177.647 364.243 207.199C363.355 243.371 348.902 277.849 325.002 304.897C325.245 305.14 344.219 325.245 344.461 325.487C352.213 324.437 359.964 327.102 365.374 332.834C374.498 342.524 374.175 357.784 364.486 367.069C354.797 376.193 339.536 375.87 330.251 366.181C324.841 360.529 322.661 352.616 324.114 344.946C304.009 323.468 288.264 306.835 288.264 306.835C322.742 279.302 339.375 242.564 340.263 206.553C340.828 183.218 334.449 160.368 323.226 140.182L341.07 123.226ZM86.9725 39.415C92.3823 45.067 94.5624 52.9798 93.109 60.6504L130.17 99.4877C126.375 102.556 119.431 107.885 111.761 116.686C91.2519 139.698 79.7864 169.007 78.8983 199.77C78.3331 223.105 83.8236 245.955 95.0468 266.302L77.2834 283.662C61.7 258.147 53.9487 228.999 54.8369 199.124C55.6443 163.113 69.6128 128.394 93.1897 101.345L72.7618 80.0287C65.0105 81.0783 57.2592 78.4138 51.8494 72.6811C42.7255 62.9919 43.0484 47.7315 52.7376 38.4461C62.346 29.4029 77.4449 29.6451 86.9725 39.415ZM378.373 3C399.367 3 416.403 21.0864 416.403 41.9988C416.403 62.9112 399.367 80.5131 378.373 80.5131C373.287 80.5939 367.069 79.6249 365.535 79.0597L314.748 127.263C288.345 92.0593 252.818 74.0537 212.285 73.004C187.659 72.4388 163.598 78.4946 142.685 91.0904L125.648 73.327C151.648 56.5325 181.845 48.216 212.931 48.9427C247.893 49.8308 281.24 62.4267 307.966 84.954L341.151 53.7872C339.94 49.9923 339.375 46.0359 339.375 42.0795C339.294 20.5212 357.38 3 378.373 3ZM210.267 88.103C214.708 88.103 219.068 88.4259 223.509 88.9911C286.569 96.9039 331.22 154.474 323.468 217.453C315.556 280.513 257.986 325.164 195.006 317.413C131.946 309.5 87.2955 251.93 95.0468 188.87C102.556 130.412 151.648 88.2644 210.267 88.103ZM162.629 184.51C163.113 202.839 172.479 218.26 188.789 226.658L179.908 268.402H239.415L230.533 226.658C246.763 217.857 256.452 203.242 256.694 184.51C256.371 158.026 235.862 138.083 209.621 137.437C183.702 138.083 163.355 157.461 162.629 184.51Z",
    fill: "#FDB516",
    stroke: "#616161",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(410 308) scale(231.06 236.029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1125_327",
    x1: 491.901,
    y1: 163.661,
    x2: 393.3,
    y2: 298.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FCFAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F5EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E9D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#D8AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C382FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B86BFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(413.06 324.793) scale(257.1 262.629)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FCCA42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#F5C033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#E9B01A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCA000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4903.79 1078.94) scale(5560.83 730.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3403.96 1078.94) scale(3571.92 730.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2816.25 1003.45) scale(3044.25 608.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3253.96 689.11) scale(3571.92 690.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4129.37 689.11) scale(4505.49 690.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4903.79 744.94) scale(5560.83 730.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1316.42 744.94) scale(1055.34 730.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1724.79 744.94) scale(1501.83 730.62)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1570.46 754.11) scale(1542.42 690.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5391.5 754.11) scale(6088.5 690.03)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3691.67 766.28) scale(4099.59 649.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1125_327",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4175.04 766.28) scale(4546.08 649.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#C7C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABABA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordsNotes);
export default __webpack_public_path__ + "static/media/keywords_notes.5554b83ed1b18a1f518fb10d1a523ad6.svg";
export { ForwardRef as ReactComponent };